/* eslint-disable no-throw-literal */
import normalizeById from 'app/utils/NormalizeById';
import ApiService from 'app/services/ApiService';

export const WORK_BEGIN = 'WORK_BEGIN';
export const WORK_ADD = 'WORK_ADD';
export const WORK_FAILURE = 'WORK_FAILURE';

export function fetchWork() {
    return async dispatch => {
        dispatch(workBegin());
        await ApiService.getWorks()
            .then(
                result => {
                    let normalized = normalizeById(result.Data, 'idWork');
                    dispatch(workAdd(normalized));
                    return normalized;
                },
                error => {
                    dispatch(workError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export const workBegin = () => ({
    type: WORK_BEGIN,
});

export const workAdd = data => ({
    type: WORK_ADD,
    payload: { data }
})

export const workError = () => ({
    type: WORK_FAILURE,
})
